;(function ($) {

    'use strict';

    // Select 2

	function templateDefault (item) {
		var $item = $(
			'<span class="select2__option-span">' + item.text + '</span>'
		);
		return $item;
	}
    function templateDefaultSelection (item) {
        var $item = $(
            '<span class="">' + item.text + '</span>'
        );
        return $item;
    }

    function templateLabelInside (item) {
        var $item = $(
            '<span class="select2__option-span">' + item.text + '</span>'
        );
        return $item;
    }

    function templateLabelInsideSmall (item) {
        var $item = $(
            '<span class="select2__option-span select2__option-span--small">' + item.text + '</span>'
        );
        return $item;
    }

    function templateLabelInsideTeaserBox (item) {
        var labelAfter = $(item.element).attr('data-label-after');

        if (typeof labelAfter === 'undefined') {
            labelAfter = '';
        }

        var $item = $(
            `<span class="select2__option-span select2__option-span--teaser"> ${item.text} ${labelAfter}</span>`
        );
        return $item;
    }

    function templateLabelInsideTeaserBoxSelection (item) {
        var labelAfter = $(item.element).attr('data-label-after');

        if (typeof labelAfter === 'undefined') {
            labelAfter = '';
        }

        var $item = $(
            `<span class="d-flex align-items-center"> ${item.text} <span class="ms-1">${labelAfter}</span></span>`
        );
        return $item;
    }

    function templateImage (item) {
        var src = $(item.element).attr('data-image');
        var img = '';
        if(src) {
            img = '<img src="' + src + '" class="me-2" /> ';
        }
        return $(
            '<span class="select2__option-span d-flex align-items-center">' + img + item.text + '</span>'
        );
    }

    function templateImageTeaserBox (item) {
        var labelAfter = $(item.element).attr('data-label-after');

        if (typeof labelAfter === 'undefined') {
            labelAfter = '';
        }

        var src = $(item.element).attr('data-image');
        var img = '';
        if(src) {
            img = '<img class="big" src="' + src + '" class="me-2" /> ';
        }
        return $(
            '<span class="select2__option-span select2__option-span--teaser d-flex align-items-center">' + img + item.text + labelAfter + '</span>'
        );
    }

    function templateImageTeaserBoxSelection (item) {
        var labelAfter = $(item.element).attr('data-label-after');

        if (typeof labelAfter === 'undefined') {
            labelAfter = '';
        }

        var src = $(item.element).attr('data-image');
        var img = '';
        if(src) {
            img = '<img src="' + src + '" class="me-2" /> ';
        }
        return $(
            '<span class="select2__option-span select2__option-span--teaser d-flex align-items-center">' + img + item.text + labelAfter + '</span>'
        );
    }

    // šablona pro multiple checkbox model
    function templateImageTeaserBoxMultipleCheckbox (item) {
        var labelAfter = $(item.element).attr('data-label-after');

        if (typeof labelAfter === 'undefined') {
            labelAfter = '';
        }

        var src = $(item.element).attr('data-image');
        var img = '';
        if(src) {
            img = '<img class="big" src="' + src + '" class="me-2" /> ';
        }
        return $(
            '<span class="select2__option-span select2__option-span--teaser select2__option-span--multiple ellipsis d-flex align-items-center"><div class="form-check"><input class="form-check-input" type="checkbox"></div>' + img + item.text + labelAfter + '</span>'
        );
    }

    // šablona pro multiple checkbox model
    function templateImageTeaserBoxSelectionMultipleCheckbox (item) {
        $(document).trigger('modelFilterOptionsUpdated');

        return ''; //vzdy vypisu prazdny string, protoze se to bude vypisovat jinde
    }

    function templateCheckboxWithImage(item) {
        if (!item.id) {
            return item.text;
        }
        var labelAfter = $(item.element).attr('data-label-after');

        if (typeof labelAfter === 'undefined') {
            labelAfter = '';
        }

        var src = $(item.element).attr('data-image');
        var img = '';
        if (src) {
            img = '<img class="big" src="' + src + '" class="me-2" />';
        }

			// let livewire = $(this).attr('data-livewire');
			// eval(livewire).set($(this).attr('id'), $(this).val());
            //
			// window.livewire.emit('domUpdated');
        var $item = $(
            '<span class="select2__option-span select2__option-span--teaser d-flex align-items-center">' +
            '<input type="checkbox" class="me-2 select2__option-checkbox" />' +
            img +
            '<span>' + item.text + labelAfter + '</span>' +
            '</span>'
        );
        return $item;
	}

    function templateCheckboxWithImageSelection(item) {
        if (!item.id) {
            return item.text;
        }
        var labelAfter = $(item.element).attr('data-label-after');

        if (typeof labelAfter === 'undefined') {
            labelAfter = '';
        }

        var src = $(item.element).attr('data-image');
        var img = '';
        if (src) {
            img = '<img class="big" src="' + src + '" class="me-2" />';
        }

        return $(
            '<span class="select2__option-span select2__option-span--teaser d-flex align-items-center">' +
            img +
            '<span>' + item.text + labelAfter + '</span>' +
            '</span>'
        );
    }

    // function templateCheckboxWithImageSelection(data) {
    //     if (!Array.isArray(data) || data.length === 0) {
    //         return 'Model';
    //     }
    //
    //     const count = data.length;
    //
    //     if (count === 1) {
    //         return 'vybrán 1';
    //     } else if ([2, 3, 4].includes(count)) {
    //         return `vybrány ${count}`;
    //     } else {
    //         return `vybráno ${count}`;
    //     }
    // }

    function initSelect2() {
        /* :not selector: avoid reinitializing select2 on livewire update if multiple livewire components with select2 elements are on the same page */
		$( '.select2:not([data-select2-id])' ).select2( {
			theme: "bootstrap-5",
			width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
			//placeholder: $( this ).data( 'placeholder' ),
			minimumResultsForSearch: -1,
			templateResult: templateDefault,
            templateSelection: templateDefaultSelection,
		} );

        $(".select2-image:not([data-select2-id])").select2({
            theme: "bootstrap-5",
            width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
            placeholder: $( this ).data( 'placeholder' ),
            minimumResultsForSearch: -1,
            templateResult: templateImage,
            templateSelection: templateImage,
        });

        // puvodni pro single model
        $(".teaser__box .select2-image").select2({
            theme: "bootstrap-5",
            width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
            placeholder: $( this ).data( 'placeholder' ),
            minimumResultsForSearch: -1,
            templateResult: templateImageTeaserBox,
            templateSelection: templateImageTeaserBoxSelection,
        });

        // novy pro multiple model
        $(".teaser__box .select2-checkbox").select2({
            theme: "bootstrap-5",
            width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
            placeholder: $( this ).data( 'placeholder' ),
            minimumResultsForSearch: Infinity,
            // allowClear: true,
            closeOnSelect: false,
            templateResult: templateImageTeaserBoxMultipleCheckbox,
            templateSelection: templateImageTeaserBoxSelectionMultipleCheckbox,
        });

        $(".select2-label-inside").select2({
            theme: "bootstrap-5",
            width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
            placeholder: $( this ).data( 'placeholder' ),
            minimumResultsForSearch: -1,
            templateResult: templateLabelInside,
        });

        $(".teaser__box .select2-label-inside").select2({
            theme: "bootstrap-5",
            width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
            placeholder: $( this ).data( 'placeholder' ),
            minimumResultsForSearch: -1,
            templateResult: templateLabelInsideTeaserBox,
            templateSelection: templateLabelInsideTeaserBoxSelection,
        });

        $(".form-select-sm.select2, .form-select-sm.select2-label-inside").select2({
            theme: "bootstrap-5",
            width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
            placeholder: $( this ).data( 'placeholder' ),
            minimumResultsForSearch: -1,
            templateResult: templateLabelInsideSmall,
        });

        $('.select2FireOnLivewireEvent').off().on('change', fireChangeLivewireEvent);
    }
    initSelect2();

    function appendSelect2ConfirmButton(select) {
        if (select.attr('data-select2-confirm-button') !== 'true') {
            return;
        }

        var dropdown = $('.select2-container--open .select2-dropdown').last();
        if (!dropdown.length || dropdown.find('.select2ConfirmButton').length) {
            return;
        }

        var confirmLabel = select.attr('data-select2-confirm-label') || 'Select';
        var confirmButton = $(
            '<div class="select2ConfirmButton">' +
                '<button type="button" class="btn btn-primary w-100"></button>' +
            '</div>'
        );

        confirmButton.find('button').text(confirmLabel);

        confirmButton.on('mousedown click', function (event) {
            event.preventDefault();
            event.stopPropagation();
        });

        confirmButton.find('button').on('click', function () {
            select.select2('close');
        });

        dropdown.append(confirmButton);
    }

    $(document).on('select2:open', '.select2FireOnLivewireEvent', function () {
        appendSelect2ConfirmButton($(this));
    });
    

    function initOnlyTeaserBoxSelect2WithoutModelFilter() {

         $(".teaser__box .select2-label-inside").select2({
            theme: "bootstrap-5",
            width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
            placeholder: $( this ).data( 'placeholder' ),
            minimumResultsForSearch: -1,
            templateResult: templateLabelInsideTeaserBox,
            templateSelection: templateLabelInsideTeaserBoxSelection,
        });

        $('.teaser__box .select2-label-inside').off().on('change', fireChangeLivewireEvent);

    }

    // function initSpecificSelect2(selector) {
    //     $(selector).select2({
    //         theme: "bootstrap-5",
    //         width: function () {
    //             return $(this).data("width")
    //                 ? $(this).data("width")
    //                 : $(this).hasClass("w-100")
    //                     ? "100%"
    //                     : "style";
    //         },
    //         placeholder: function () {
    //             return $(this).data("placeholder");
    //         },
    //         minimumResultsForSearch: -1,
    //         templateResult: templateCheckboxWithImage,
    //         templateSelection: templateCheckboxWithImageSelection,
    //     });

    //     $(selector).off().on("change", fireChangeLivewireEvent);
    // }

    // select2 and livewire
    // default
    var allModels = true;
    function fireChangeLivewireEvent() {
        var values = $(this).val();
        var valuesUpdated = values;

        // pouze pro model filter -
        if ($(this).attr('id') == 'carModelId') {
            if (allModels) {
                allModels = false;
                valuesUpdated = values.filter(value => value !== ""); // Odstraní allModels z values
            } else if (values.includes("")) {
                allModels = true;
                valuesUpdated = [""];
            }
        }

        let livewire = $(this).attr('data-livewire');
        eval(livewire).set($(this).attr('id'), valuesUpdated);

        // window.livewire.emit('domUpdated');
    }

    function setLivewireHomepageBannerValue(select, property, value) {
        var livewire = select.attr('data-livewire');

        if (!livewire) {
            return;
        }

        try {
            eval(livewire).set(property, value);
        } catch (error) {
            // The browser can restore this page from bfcache before Livewire is ready.
        }
    }

    function resetHomepageBannerFormAfterBrowserBack() {
        var homepageBanner = $('.teaser__box');

        if (!homepageBanner.length) {
            return;
        }

        var modelSelect = homepageBanner.find('#carModelId');
        modelSelect.val(['']).trigger('change.select2');
        homepageBanner.find('#carModelFilter').attr('data-selected-options-label', '');
        allModels = true;
        setLivewireHomepageBannerValue(modelSelect, 'carModelId', ['']);

        ['mileageRange', 'priceRange', 'ageRange'].forEach(function (property) {
            var select = homepageBanner.find('#' + property);
            select.val('').trigger('change.select2');
            setLivewireHomepageBannerValue(select, property, null);
        });

        homepageBanner.find('.js-homepage-banner-filter-link').each(function () {
            var url = new URL($(this).attr('href'), window.location.href);
            url.search = '';
            $(this).attr('href', url.toString());
        });

        formatSelectionMultiple();
    }

    window.addEventListener('pageshow', function (event) {
        var navigationEntries = performance.getEntriesByType ? performance.getEntriesByType('navigation') : [];
        var isBackForwardNavigation = navigationEntries.length && navigationEntries[0].type === 'back_forward';

        if (event.persisted || isBackForwardNavigation) {
            resetHomepageBannerFormAfterBrowserBack();
        }
    });

    document.addEventListener('livewire:init', () => {
        Livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
            // Equivalent of 'message.sent'

            succeed(({ snapshot, effect }) => {
                // Equivalent of 'message.received'

                queueMicrotask(() => {
                    // Equivalent of 'message.processed'
                    if ($(component.el).attr('id') == 'filter') {
                        initSelect2();
                    }

                    // if ($(component.el).find(".select2-checkbox").length) {
                    //     initSpecificSelect2($(component.el).find(".select2-checkbox"));
                    // }

                    // pokud je na strance vice livewire komponent s select2, tak reinit select2 pouze pokud je v komponente select2
                    if ($(component.el).find('.select2FireOnLivewireEvent').length) { 
                        
                        // pokud je otevreny dropdown modelu, tak nebudu inicializovat select2, protoze by se zavrel
                        if ($(component.el).find('#carModelFilter .select2-container--open').length) {
                            initOnlyTeaserBoxSelect2WithoutModelFilter();
                        }
                        else {
                            initSelect2(); // Call your select2 initialization logic
                        }
                        
                    }
                
                })
            })

            fail(() => {
                // Equivalent of 'message.failed'
            })
        })
    });

    // reinit select2 on filter update (filter in HP hero)
    // $(document).off().on('heroFilterOptionsUpdated', function () {
    //     // initSelect2();
    //     // initSpecificSelect2(".select2-checkbox");

    //     // formatSelectionMultiple();

    //     // alert('heroFilterOptionsUpdated');
    // });


    // select 2 on HP - model filter
    function formatSelectionMultiple() {
        var text = $('#carModelFilter').attr('data-selected-options-label');
        $('#carModelId').next().find('.select2-selection__rendered').html(`<li class="summary" title="">${text}</li>`);
    }

    $(document).on('modelFilterOptionsUpdated', function () {
        formatSelectionMultiple();
    });

    function observeDataAttributeChange(selector, attributeName) {
        // Vybereme element, který chceme sledovat
        const targetElement = document.querySelector(selector);

        // Vytvoříme MutationObserver
        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === "attributes" && mutation.attributeName.startsWith("data-")) {
                    // alert(targetElement.getAttribute(mutation.attributeName));
                    formatSelectionMultiple();
                }
            });
        });

        // Konfigurace, aby sledoval změny atributů
        const config = { attributes: true, attributeFilter: [attributeName] }; // můžeš specifikovat konkrétní atributy nebo nechat prázdné pro všechny data atributy

        // Spustíme sledování
        observer.observe(targetElement, config);
    }

    if ($('#carModelFilter').length) {
        observeDataAttributeChange("#carModelFilter", "data-selected-options-label");
    }

})(jQuery);
